var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNumber5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 121,
    viewBox: "0 0 65 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.6044 112.738C45.3532 118.011 37.6063 120.83 29.6293 120.83C28.4021 120.83 26.9256 120.83 25.5833 120.581C15.8805 119.469 6.92559 113.946 0.310059 104.761L5.58331 100.964C11.2209 108.941 18.2199 113.122 26.3312 114.215C34.0589 115.192 41.3071 112.872 47.194 107.714C60.195 96.554 61.5564 75.3267 50.147 61.8272C44.8738 55.576 37.3762 52.0094 29.2841 52.0094C21.1921 52.0094 13.3302 55.3267 7.55838 61.8272L1.92079 68.3277V0.830078H57.5104V7.33056H8.4213V52.1244C12.7166 48.4427 20.8086 45.3747 29.2841 45.4897C39.102 45.6048 48.6705 50.1494 55.171 57.762C68.5555 73.6009 66.8297 99.3536 51.6044 112.738Z",
    fill: "#949494"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumber5);
export default __webpack_public_path__ + "static/media/NUMBER_5.6d6541ddb40d7b88d967c304a876c7a0.svg";
export { ForwardRef as ReactComponent };